import cn from 'classnames';
import { motion, useReducedMotion } from 'framer-motion';

const RATIO = 34 / 36;

/**
 * A cup with steam that keeps rising. Sits inline in the copy, so it stays
 * on screen under reduced motion — only the steam stops moving.
 */
export function SteamingCoffee({ size = 30, className }: { size?: number; className?: string }) {
    const reduced = useReducedMotion();

    const wisps = [
        { d: 'M13 11c-2.4-2.2.8-3.6-1.4-5.8', delay: 0 },
        { d: 'M18 10.4c-2.4-2.2.8-3.8-1.4-6.2', delay: 0.7 },
        { d: 'M23 11c-2.4-2.2.8-3.6-1.4-5.8', delay: 1.4 }
    ];

    return (
        <svg viewBox="0 0 36 34" width={size} height={size * RATIO} className={cn('shrink-0', className)} aria-hidden="true">
            {wisps.map((wisp) =>
                reduced ? (
                    <path key={wisp.d} d={wisp.d} stroke="var(--accent)" strokeWidth="1.6" strokeLinecap="round" fill="none" opacity="0.45" />
                ) : (
                    <motion.path
                        key={wisp.d}
                        d={wisp.d}
                        stroke="var(--accent)"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        fill="none"
                        initial={{ opacity: 0, y: 3 }}
                        animate={{ opacity: [0, 0.6, 0], y: [3, -4, -7] }}
                        transition={{ duration: 2.6, delay: wisp.delay, repeat: Infinity, ease: 'easeOut' }}
                    />
                )
            )}

            <path d="M26 15c3.4 0 5.4 1.4 5.4 4s-2 4.2-5.4 4.2" stroke="#E9E5E0" strokeWidth="2.4" strokeLinecap="round" fill="none" />
            <path d="M6 14.4h21v7.2a7 7 0 0 1-7 7h-7a7 7 0 0 1-7-7z" fill="#E9E5E0" />
            <ellipse cx="16.5" cy="14.6" rx="10.5" ry="2.4" fill="#E9E5E0" />
            <ellipse cx="16.5" cy="14.6" rx="8.2" ry="1.7" fill="var(--accent)" />
            <path d="M6.5 30.8h20" stroke="#E9E5E0" strokeWidth="2" strokeLinecap="round" opacity="0.3" />
        </svg>
    );
}

export default SteamingCoffee;
